import classNames from 'classnames';

import * as Styles from './Button.styles';

const Button = ({
  type = 'button',
  variant = 'contained',
  children,
  ...rest
}) => {
  return (
    <Styles.Button type={type} variant={variant} {...rest}>
      {children}
    </Styles.Button>
  );
};

export default Button;

export const IconButton = ({ variant = 'contained', children, ...rest }) => {
  return (
    <Styles.IconButton variant={variant} {...rest}>
      {children}
    </Styles.IconButton>
  );
};

export const LinkButton = ({
  href,
  target = '_self',
  className = '',
  text,
}) => {
  return (
    <a
      href={href}
      target={target}
      className={classNames(
        'inline-block text-center px-4 py-2 w-24 text-xs font-medium leading-5 text-white transition-colors duration-150 bg-primary-main border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple',
        className
      )}
    >
      {text}
    </a>
  );
};

export const Link = ({ href, target = '_self', className = '', text }) => {
  return (
    <a
      href={href}
      target={target}
      className={classNames(
        'inline-block text-center px-4 py-2 font-medium leading-5 text-primary-main transition-colors duration-150 border border-transparent rounded-lg hover:text-purple-700 focus:outline-none focus:shadow-outline-purple',
        className
      )}
    >
      {text}
    </a>
  );
};
